module.exports = __webpack_public_path__ + "static/img/06.587552ee.png";